import { render, staticRenderFns } from "./ReviewDashboard.vue?vue&type=template&id=150560c3&scoped=true"
import script from "./ReviewDashboard.vue?vue&type=script&lang=js"
export * from "./ReviewDashboard.vue?vue&type=script&lang=js"
import style0 from "./ReviewDashboard.vue?vue&type=style&index=0&id=150560c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150560c3",
  null
  
)

export default component.exports